import { lazy, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
// Country codes for matching: AT, ES, DE, FR, UK, etc.
// Pattern: 2-letter country code followed by 6 alphanumeric characters
// Add new country codes to this array as needed
const COUNTRY_CODES = [
  'AT',
  'ES',
  'DE',
  'FR',
  'UK',
  'IT',
  'NL',
  'BE',
  'LU',
  'CH',
  'PL',
  'CZ',
  'SK',
  'HU',
  'RO',
  'BG',
  'GR',
  'HR',
  'SI',
  'EE',
  'LV',
  'LT',
  'FI',
  'SE',
  'NO',
  'DK',
  'IS',
  'IE',
  'GB',
  'PT',
];
const SHORT_CODE_REGEX = new RegExp(`^(${COUNTRY_CODES.join('|')})[A-Z0-9]{6}$`);
const NotFoundPage = lazy(() => import('@/pages/NotFound'));

const ShortCodeRedirect = () => {
  const { code } = useParams<{ code: string }>();
  const location = useLocation();

  const isShortCode = !!code && SHORT_CODE_REGEX.test(code);

  useEffect(() => {
    if (!isShortCode) return;
    const isDevelopment = import.meta.env.DEV;
    const baseUrl = isDevelopment
      ? 'http://localhost:8090/access'
      : 'https://app2.verdea.app/access';
    // Preserve query parameters if any
    const redirectUrl = `${baseUrl}/${code}${location.search}`;
    if (isDevelopment) {
      console.log(`Short code redirect: ${code} -> ${redirectUrl}`);
    }
    window.location.replace(redirectUrl);
  }, [isShortCode, code, location.search]);

  // Not a short code: this route also catches every unknown single-segment URL
  if (!isShortCode) return <NotFoundPage />;

  // Simple loading spinner
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
      }}
    >
      <div
        style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3498db',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}
      />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default ShortCodeRedirect;
